import { render, staticRenderFns } from "./UserBatchDialog.vue?vue&type=template&id=4672d0e6&scoped=true&"
import script from "./UserBatchDialog.vue?vue&type=script&lang=js&"
export * from "./UserBatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserBatchDialog.vue?vue&type=style&index=0&id=4672d0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4672d0e6",
  null
  
)

export default component.exports